import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { Qualification } from './types/Qualification';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<Qualification>('GET', `${APIV2_URL}/user/${userId}/qualification`);
